var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21749504,5.36772096 L4.21749504,5.84698176 C4.21749504,6.00579681 4.08875361,6.13453824 3.92993856,6.13453824 L0.67096512,6.13453824 C0.512150072,6.13453824 0.38340864,6.00579681 0.38340864,5.84698176 L0.38340864,1.4377824 C0.38340864,1.27896735 0.512150072,1.15022592 0.67096512,1.15022592 L1.53363456,1.15022592 L1.53363456,4.69675584 C1.53363456,5.0667332 1.83462232,5.36772096 2.20459968,5.36772096 L4.21749504,5.36772096 Z M4.21749504,1.24607808 L4.21749504,0 L2.20459968,0 C2.04578463,0 1.9170432,0.128741432 1.9170432,0.28755648 L1.9170432,4.69675584 C1.9170432,4.85557089 2.04578463,4.98431232 2.20459968,4.98431232 L5.46357312,4.98431232 C5.62238817,4.98431232 5.7511296,4.85557089 5.7511296,4.69675584 L5.7511296,1.53363456 L4.50505152,1.53363456 C4.34689546,1.53363456 4.21749504,1.40423414 4.21749504,1.24607808 Z M5.6669115,0.874303496 L4.8768261,0.0842181041 C4.8228996,0.0302943765 4.74976134,0 4.67349971,0 L4.60090368,0 L4.60090368,1.15022592 L5.7511296,1.15022592 L5.7511296,1.07762989 C5.7511296,1.00136826 5.72083522,0.928230002 5.6669115,0.874303496 L5.6669115,0.874303496 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4870d1fd6b2254e3cbdb28f90006c1d9.svg";
export { ForwardRef as ReactComponent };